import React, {useState} from 'react'
import Modal from "react-bootstrap/Modal";

const LegendEditModal = ({data,isOpen,closeModal,categories,associations,handleSubmit}) => {

  const [indicator, setIndicator] = useState(data.indicator || '')
  const [basicMeaning, setBasicMeaning] = useState(data.basic_meaning || '')
  const [category, setCategory] = useState(data.legend_category_id)
  const [association, setAssociation] = useState(data.legend_association_id || '')
  const [purpose, setPurpose] = useState(data.purpose || '')
  const [googleDOCName, setGoogleDOCName] = useState(data.google_doc_name || '')
  const [googleDOCLink, setGoogleDOCLink] = useState(data.google_doc_link || '')

  const handleFormSumbit = (e) => {
    e.preventDefault()
    const formData = {
      indicator: indicator,
      basic_meaning: basicMeaning,
      legend_category_id: category,
      legend_association_id: association,
      purpose: purpose,
      google_doc_name: googleDOCName,
      google_doc_link: googleDOCLink
    }
    handleSubmit(data.id,formData)
    setIndicator('')
    setBasicMeaning('')
    setPurpose('')
    setGoogleDOCName('')
    setGoogleDOCLink('')
    closeModal()
  }

  return (
       <>
       <Modal show={isOpen} onHide={closeModal}>
        <Modal.Header className="text-white" style={{"backgroundColor": "#047C7C"}} closeButton>
          <Modal.Title>Edit Legend Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleFormSumbit}>
            <div className="form-group">
              <label htmlFor="category">Select Category</label>
              <select className='form-control' name="category" id="category" defaultValue={category} onChange={e => setCategory(e.target.value)}>
                {
                  categories.map(cat => <option key={cat.name} value={cat.id}>{cat.name}</option>)
                }
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="category">Select Association</label>
              <select className='form-control' name="association" id="association" defaultValue={association} onChange={e => setAssociation(e.target.value)}>
                {
                  associations.map(item => <option key={item.associations.name} value={item.associations.id}>{item.associations.name}</option>)
                }
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="indicator">Indicator</label>
              <input
                className="form-control"
                id="indicator"
                type="text"
                name="indicator"
                value={indicator}
                onChange={(e) => setIndicator(e.target.value)}
                placeholder="Enter Indicator"
              />
            </div>
            <div className="form-group">
              <label htmlFor="basic-meaning">Basic Meaning</label>
              <textarea
                className="form-control"
                id="basic-meaning"
                type="text"
                name="basic-meaning"
                value={basicMeaning}
                onChange={(e) => setBasicMeaning(e.target.value)}
                placeholder="Type basic meaning here"
              />
            </div>
            <div className="form-group">
              <label htmlFor="purpose">Purpose</label>
              <textarea
                className="form-control"
                id="purpose"
                type="text"
                name="purpose"
                value={purpose}
                onChange={(e) => setPurpose(e.target.value)}
                placeholder="Type purpose here"
              />
            </div>
            <div className="form-group">
              <label htmlFor="google_doc_name">Google DOC Name</label>
              <input
                className="form-control"
                id="google_doc_name"
                type="text"
                name="google_doc_name"
                value={googleDOCName}
                onChange={(e) => setGoogleDOCName(e.target.value)}
                placeholder="Type google doc name here"
              />
            </div>
            <div className="form-group">
              <label htmlFor="google_doc_link">Link</label>
              <input
                className="form-control"
                id="google_doc_link"
                type="url"
                name="google_doc_link"
                value={googleDOCLink}
                onChange={(e) => setGoogleDOCLink(e.target.value)}
                placeholder="Type link to google doc here"
              />
            </div>
            <hr />
            <div className="form-group float-right">
              <button className="add-btn rounded" type="submit">
                Edit
              </button>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <h5>TUC SYSTEM</h5>
        </Modal.Footer>
       </Modal>
    </>
  )
}

export default React.memo(LegendEditModal)
